import { render, staticRenderFns } from "./SendMessageLimitWarning.vue?vue&type=template&id=0759a05b&"
import script from "./SendMessageLimitWarning.vue?vue&type=script&lang=js&"
export * from "./SendMessageLimitWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports